import * as React from 'react';

import TriangleAlert16 from './TriangleAlert16';

export const triangleAlert16 = () => <TriangleAlert16 />;

export default {
    title: 'Icon/Line/TriangleAlert16',
    component: TriangleAlert16,
    parameters: {
        notes: "`import TriangleAlert16 from 'box-ui-elements/es/icon/line/TriangleAlert16';`",
    },
};
